import {
  Camera,
  Search,
  Home,
  Database,
  Users,
  BookOpen,
  Info,
  Heart,
  BookMarked,
  Settings
} from "lucide-react";

/**
 * Shared navigation configuration
 * Single source of truth for all navigation links across the app
 */

export const investigateLinks = [
  { path: "/scan", label: "Scan Barcode", icon: Camera },
  { path: "/search", label: "Search & Generate", icon: Search },
  { path: "/journal", label: "My Journal", icon: BookMarked },
];

export const userLinks = [
  { path: "/journal", label: "Investigation Journal", icon: BookMarked },
  { path: "/personalize", label: "Personalization", icon: Settings },
];

export const mainLinks = [
  { path: "/", label: "Home", icon: Home },
  { path: "/repository", label: "Repository", icon: Database },
  { path: "/contribute", label: "Contribute", icon: Users },
  { path: "/sources", label: "Sources", icon: BookOpen },
  { path: "/about", label: "About", icon: Info },
  { path: "/personalize", label: "Settings", icon: Settings },
  { path: "/donate", label: "Donate", icon: Heart },
];

